const { getElement } = window.BAO.Utils;
class ProductQuickAdd extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["slot"];
  }

  static get observedAttributes() {
    return ["data-product-handle"];
  }

  attributeChangedCallback(name) {
    const hasProductHandle = !!this.dataset?.productHandle?.length;

    if (name !== "data-product-handle" || !hasProductHandle) return;

    this.renderProductOptions();
  }

  async renderProductOptions() {
    this.setAttribute("aria-busy", true);

    await this.render();

    this.setAttribute("aria-busy", false);
  }

  async render() {
    const html = await this.quickAddHTML();

    if (!html.length) {
      this.remove();
      return;
    }

    this.els.slot.element.innerHTML = html;
  }

  async quickAddHTML() {
    const { productHandle } = this.dataset;

    const html =
      window.sessionStorage.getItem(this.storageKey) ||
      (await window.BAO.sectionRenderer.fetchSingle(
        "product-quick-add",
        `/products/${productHandle}`,
      ));

    window.sessionStorage.setItem(this.storageKey, html);

    return window.BAO.sectionRenderer.getInnerHtml(html);
  }

  get storageKey() {
    return `product-quick-add-${this.dataset?.productHandle}`;
  }
}

if (!customElements.get("product-quick-add")) {
  customElements.define("product-quick-add", ProductQuickAdd);
}

class ProductQuickAddTrigger extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return ["data-product-handle"];
  }

  setupListeners() {
    super.setupListeners();

    if (!this.productQuickAddEl) return;

    this.listeners.add(this, "click", this.handleClick.bind(this));
  }

  handleClick(event) {
    if (!event.target.closest("button")) return;

    this.productQuickAddEl.setAttribute(
      "data-product-handle",
      this.dataset.productHandle,
    );
  }

  get productQuickAddEl() {
    return getElement("product-quick-add");
  }
}

if (!customElements.get("product-quick-add-trigger")) {
  customElements.define("product-quick-add-trigger", ProductQuickAddTrigger);
}
